import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { deepOrange, deepPurple } from '@mui/material/colors';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

const getDashboardItem = (data: any) => {
	return [{
		label: 'Categories',
		total: data.categoriesCount,
		url: '/categories'
	}, {
		label: 'Sub Categories',
		total: data.subCategoriesCount,
		url: '/sub-categories'
	}, {
		label: 'Products',
		total: data.productsCount,
		url: '/products'
	}, {
		label: 'Sellers',
		total: data.topSellersCount,
		url: '/sellers'
	}, {
		label: 'Customers',
		total: data.customersCount,
		url: '/customers'
	}, {
		label: 'Orders',
		total: data.ordersCount || 0,
		url: '/orders'
	}]
}

const getColor = (index: number) => {
	let color: any = null
	switch(index) {
		case 0:
			color = deepOrange[500]
			break;
		case 1:
			color = deepPurple[500]
			break;
		case 2:
			color = '#ff1744';
			break;
		default:
			color = '#009688';					
	}
	return color;
}

interface DashboardItemType {
	label: string;
	total: number;
	url: string
}
interface DashboardItemProps {
	data: any;
	setSelectedListItemHandler: (path: string) => void;
}

const DashboardItem = (props: DashboardItemProps) => {
	const { data, setSelectedListItemHandler } = props;
	const dashboardItems = data && getDashboardItem(data)
	return dashboardItems &&
		dashboardItems.length > 0 && <>
		<Typography variant='body1' mb={1}><b>Database:</b> {data.database.name}</Typography>
		<Grid container spacing={2} textAlign='center'>
			{dashboardItems.map((item: DashboardItemType, index: number) => {
				return <Grid item xs={6} sm={4} md={3} key={index}>
					<Card onClick={() => setSelectedListItemHandler(item.url)}>
						<Stack direction="row" 
							spacing={2} justifyContent='center'
							border="2px solid #1976d2"
							padding="8px"
						>
							<Avatar sx={{ 
									width: '120px', height: '120px', paddingTop: '0px',
									bgcolor: getColor(index) }}>{item.total}</Avatar>
						</Stack>
						<CardContent style={{
								backgroundColor: '#1976d2',
								color: '#fff',
								marginTop: '0px'
							}}
						>
							<Typography gutterBottom variant="h5" component="div">
								{item.label}
							</Typography>
						</CardContent>
					</Card>
				</Grid>
			})}
		</Grid>
	</>
}

export default DashboardItem;
